const styles = {
    blue: {
        color: 'rgb(33,77,142)',
        paddingRight: "0"
    },
    red: {
        color: "rgb(220,38,72)",
        paddingLeft: "0"
    },
    button: {
        width: "90vw",
        marginLeft: "5vw",
        marginTop: "10vh",
        backgroundColor: "rgb(33,77,142)",
        border: "1px solid rgb(33,77,142)",
        borderRadius: "0",
        height: "10vh",
    },
    text: {
        width: "90vw",
        marginLeft: "5vw",
        marginTop: "5vh"
    }
}

export default styles;
